/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-26 14:57:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-04-22 13:45:29
 * @FilePath: \watherfocast2\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dataV from '@jiaminghi/data-view'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'leaflet/dist/leaflet.css'
Vue.use(dataV)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
